<template>
<div ref="parent" class="urban-docs-wrapper">
  <div class="n-row urban-docs-grid">
    <div v-for="item in viewedPlates" class="n-col-24 n-col-md-12 n-col-lg-8 n-mb-2">
      <div class="download-block download-block_height_equal">
        <div class="download-block__title" v-html="item.title" />
        <a v-if="item.url" :href="item.url" class="button button_type_download size_xl second-font no-border" target="_blank">
          <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 18L7 12L17 12L12 18Z" fill="none"></path>
            <path d="M12 12L12 4" stroke="none"></path>
            <path d="M17 21H7" stroke="none"></path>
          </svg>
          <span v-if="item.documentType && item.documentSize" v-html="`${item.documentType}, ${item.documentSize}`" />
          <span v-if="!item.documentType && item.documentSize" v-html="item.documentSize"></span>
          <span v-if="item.documentType && !item.documentSize" v-html="item.documentType"></span>
        </a>
        <p class="second-font lh-sm" v-else-if="item.text" v-html="item.text" />
      </div>
    </div>
  </div>
  <div class="n-row urban-docs-footer" v-if="data.length > viewedPlatesCount">
    <div class="n-col-24 text-center">
      <load-more-button
        :text="isShowMore ? 'Скрыть' : 'Показать ещё'"
        @cb="loadMore"
      />
    </div>
  </div>
</div>
</template>

<script>
import LoadMoreButton from '../../../vue-components/LoadMoreButton';
import scrollIt from '../../../modules/scroll-it';

export default {
  name: 'UrbanDocsPlate',
  components: { LoadMoreButton },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShowMore: false,
      viewedPlatesCount: document.documentElement.clientWidth <= 1124 ? 4 : 6,
      viewedPlatesStart: 0,
      isDisable: false
    };
  },
  computed: {
    viewedPlates() {
      const sliceCount = this.isShowMore ? this.data.length : this.viewedPlatesCount;
      return this.data.slice(0, sliceCount);
    },
  },
  methods: {
    loadMore() {
      if (this.isDisable) return;
      this.isShowMore = !this.isShowMore;
      this.isDisable = true;

      if (!this.isShowMore) {
        scrollIt(this.$refs.parent, 500);
      }

      setTimeout(() => {
        this.isDisable = false;
      }, 1000);
    },
  }
};
</script>
